import RadiusProps from './RadiusProps';

const radius: RadiusProps = {
  xl: {
    value: 0,
    get rem() {
      return `${this.value}rem`;
    },
  },
  l: {
    value: 0,
    get rem() {
      return `${this.value}rem`;
    },
  },
  m: {
    value: 0,
    get rem() {
      return `${this.value}rem`;
    },
  },
  s: {
    value: 0,
    get rem() {
      return `${this.value}rem`;
    },
  },
  xs: {
    value: 0,
    get rem() {
      return `${this.value}rem`;
    },
  },
};

export default radius;
